import { DeviceLinkDto, ControlledDto, ControllerDto } from '../../installation/api'

export const getEmcSerialNumber = (deviceLink: Nullable<DeviceLinkDto>): string => {
  return deviceLink.deviceId ? `FR2-${deviceLink.deviceId}` : ''
}

export const getStorageSerialNumber = (deviceLink: Nullable<DeviceLinkDto>): string => {
  return parseStorageSerialNumber(deviceLink.deviceId)
}

export const getEvseSerialNumber = (evse: Nullable<ControlledDto>): string => {
  if (evse.media === 'ModbusTCP') return evse.mediaParameters?.macAddress ?? ''
  if (evse.media === 'EEBus') return evse.evseSubTypeParameters?.wallboxId ?? ''
  return ''
}

export const getIoSerialNumber = (io: Nullable<ControllerDto>): string => {
  if (io.type === 'IOController') {
    if (io.media === 'ModbusRTU') return `${io.mediaParameters?.address ?? ''}`
    if (io.media === 'Storage') return parseStorageSerialNumber(io.mediaParameters?.deviceLinkId?.toString() ?? null)
    return ''
  }
  if (io.type === 'MyPvHeater') return io.mediaParameters?.serialNumber ?? ''
  if (io.type === 'HpWithISG') return io.mediaParameters?.macAddress ?? ''
  return ''
}

const parseStorageSerialNumber = (deviceId: string | null): string => {
  if (!deviceId) return ''
  const storageSerialnumberPrefix = deviceId?.startsWith?.('33') ? 'XCM' : 'XEM'
  return `${storageSerialnumberPrefix}-${deviceId}`
}
